// leaderboardTabReducer.js

const initialState = {
    tab: "3",
    week: "",
    dailyDate: "",
    day: "",
  };
  
  export default function leaderboardTabReducer(state = initialState, action) {
    switch (action.type) {
      // --- TAB ---
      case "SET_TAB":
        return { ...state, tab: action.payload };
  
      // --- WEEK ---
      case "SET_WEEK_DAY":
        return { ...state, week: action.payload };
      case "REMOVE_WEEK_DAY":
        return { ...state, week: "" };
  
      // --- DAILY DATE ---
      case "SET_DAILY_DATE":
        return { ...state, dailyDate: action.payload };
      case "REMOVE_DAILY_DATE":
        return { ...state, dailyDate: "" };
  
      // --- DAY ---
      case "SET_DAY":
        return { ...state, day: action.payload };
      case "REMOVE_DAY":
        return { ...state, day: "" };
  
      // --- BOTH DATE + DAY ---
      case "SET_DATE_AND_DAY":
        return { ...state, dailyDate: action.payload.date, day: action.payload.day };
  
      case "REMOVE_DATE_AND_DAY":
        return { ...state, dailyDate: "", day: "" };
  
      default:
        return state;
    }
  }
  